import { Badge } from '@agion/ui'
import type { ImageStatus } from './infra_image.service'

const statusVariant: Record<ImageStatus, 'success' | 'info' | 'error' | 'default'> = {
  available: 'success',
  building: 'info',
  failed: 'error',
  deprecated: 'default',
  deleted: 'default',
}

interface Props {
  status: ImageStatus
}

export function ImageStatusBadge({ status }: Props) {
  return <Badge variant={statusVariant[status] ?? 'default'}>{status}</Badge>
}
